"use client";

import Link from "next/link";

import Icon from "@/components/ui/icon";
import { NavDropdown } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";

import { allSites } from "./navigation.config";

export default function SecondaryNavbar() {
  return (
    <Navbar expand={"lg"} className="bg-body-tertiary p-0" id="secondary-navbar">
      <Container className="border-bottom py-1">
        <Link href={"/about-us"} className="text-secondary text-decoration-none me-3">
          <small>About Us</small>
        </Link>

        <NavDropdown title={<small>All Gateway Sites</small>} className="text-secondary me-3">
          {allSites
            .filter((item) => item.available && item.url)
            .map((item) =>
              item.current ? (
                <NavDropdown.Item key={item.id} disabled className="g2-text-orange">
                  {item.label}
                </NavDropdown.Item>
              ) : (
                <NavDropdown.Item key={item.id} href={item.url} target="_blank" rel="noopener noreferrer">
                  {item.label}
                </NavDropdown.Item>
              ),
            )}
        </NavDropdown>

        <NavDropdown title={<small>Help</small>} className="text-secondary me-auto">
          <Link key="tutorials" href="/help/tutorials" className="dropdown-item">
            Tutorials
          </Link>
          <Link key="faqs" href="/help/faqs" className="dropdown-item">
            FAQs
          </Link>
        </NavDropdown>
        <a href="https://www.facebook.com/groups/1180198565366933" target="_blank">
          <Icon icon="facebook" me={3} />
        </a>
        <a href="https://www.facebook.com/groups/1180198565366933" target="_blank">
          <Icon icon="twitter-x" me={0} />
        </a>
      </Container>
    </Navbar>
  );
}
